import { useSelector } from 'react-redux';

import { IApplicationState } from '../../../types/redux';

export const useRegionName = (): string => {
  const addressDetails = useSelector((state: IApplicationState) => state.newbuilding.geo.addressDetails);

  return (
    addressDetails.find(address => address.locationTypeId === 1)?.fullName ??
    addressDetails.find(address => address.locationTypeId === 2)?.fullName ??
    addressDetails[0]?.fullName ??
    ''
  );
};
